import { Link } from "react-router-dom";
import { Star, MapPin, Shield, Heart, AlertTriangle } from "lucide-react";
import { Badge } from "./ui/badge";

export default function ParkingCard({ spot, isFavorite, onToggleFavorite }) {
  const defaultImage = "https://images.unsplash.com/photo-1548343361-02248be15911?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";
  const hostCanReceivePayments = spot.host_can_receive_payments !== false;

  return (
    <div className="parking-card relative" data-testid={`parking-card-${spot.id}`}>
      <Link to={`/spot/${spot.id}`} className="block">
        <div className="relative">
          <img
            src={spot.images?.[0] || defaultImage}
            alt={spot.title}
            className="parking-card-image"
            loading="lazy"
          />
          <div className="absolute top-3 right-3 flex flex-col gap-2 items-end">
            {spot.has_plazafy_gate && (
              <Badge className="bg-violet-500/90 text-white border-violet-400/50 flex items-center gap-1">
                <Shield className="w-3 h-3" />
                Gate
              </Badge>
            )}
            {!hostCanReceivePayments && (
              <Badge className="bg-amber-500/90 text-white border-amber-400/50 flex items-center gap-1" title="El anfitrión aún no ha configurado sus cobros">
                <AlertTriangle className="w-3 h-3" />
                Cobros pendientes
              </Badge>
            )}
            {spot.is_available !== false ? (
              <Badge className="badge-available">Disponible</Badge>
            ) : (
              <Badge className="badge-occupied">Ocupado</Badge>
            )}
          </div>
        </div>

        <div className="p-4">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h3 className="font-semibold text-white line-clamp-1">{spot.title}</h3>
            {spot.rating > 0 && (
              <div className="flex items-center gap-1 text-sm">
                <Star className="w-4 h-4 fill-amber-400 text-amber-400" />
                <span className="text-white">{spot.rating.toFixed(1)}</span>
              </div>
            )}
          </div>

          <div className="flex items-center gap-1 text-gray-400 text-sm mb-3">
            <MapPin className="w-4 h-4" />
            <span className="line-clamp-1">{spot.address}, {spot.city}</span>
          </div>

          <div className="flex flex-wrap gap-2 mb-4">
            {spot.features?.slice(0, 3).map((feature, index) => (
              <span key={index} className="feature-badge">
                {feature}
              </span>
            ))}
            {spot.features?.length > 3 && (
              <span className="feature-badge">+{spot.features.length - 3}</span>
            )}
          </div>

          <div className="flex items-end justify-between">
            <div>
              <span className="price-display text-xl text-white">€{spot.price_hour.toFixed(2)}</span>
              <span className="text-gray-400 text-sm">/hora</span>
            </div>
            {spot.price_month && (
              <div className="text-right">
                <span className="text-gray-400 text-xs">desde</span>
                <div>
                  <span className="price-display text-sm text-gray-300">€{spot.price_month.toFixed(0)}</span>
                  <span className="text-gray-500 text-xs">/mes</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </Link>

      {/* Favorite button */}
      {onToggleFavorite && (
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onToggleFavorite(spot.id);
          }}
          className="absolute top-3 left-3 p-2 rounded-full bg-black/40 backdrop-blur-sm hover:bg-black/60 transition-colors z-10"
          data-testid={`favorite-btn-${spot.id}`}
        >
          <Heart 
            className={`w-4 h-4 transition-colors ${isFavorite ? 'fill-red-500 text-red-500' : 'text-white'}`} 
          />
        </button>
      )}
    </div>
  );
}
